import {
  useCreateInstructorMutation,
  useGetAllInstructors,
} from '~entities/instructors';

import Creatable from '~shared/components/select/creatable';

export interface InstructorOption {
  label: string;
  value: string;
}

export interface InstructorSelectorProps {
  value: Array<InstructorOption>;
  onChange: (value: Array<InstructorOption> | undefined | null) => void;
}
export const InstructorSelector = ({
  value,
  onChange,
}: InstructorSelectorProps) => {
  const { data, isFetching } = useGetAllInstructors();
  const mutation = useCreateInstructorMutation();
  const options = data?.map((instructor) => ({
    label: instructor.fieldName,
    value: instructor._id,
  }));

  return (
    <Creatable
      value={value}
      onChange={(option) => {
        const opt = option as Array<InstructorOption> | null | undefined;
        onChange(opt);
      }}
      onCreateOption={async (inputValue: string) => {
        const instructor = await mutation.mutateAsync({
          fieldName: inputValue,
        });
        onChange([
          ...value,
          { label: instructor.fieldName, value: instructor._id },
        ]);
      }}
      isMulti
      placeholder='Select Instructors'
      options={options}
      isLoading={isFetching}
      classNames={{
        control: () =>
          'border border-input shadow-sm bg-background hover:border-accent rounded-md',
        option: () =>
          'text-black hover:bg-accent hover:text-accent-foreground cursor-pointer px-2',
        multiValue: () => 'bg-secondary rounded-md border border-input',
        input: () => 'text-black',
        menu: () =>
          'bg-background border border-input rounded-md mt-1 shadow-sm',
        multiValueLabel: () => 'text-black px-2 py-1',
        multiValueRemove: () =>
          'text-black hover:bg-destructive hover:text-destructive-foreground rounded-r-md px-2 py-1',
        placeholder: () => 'text-muted-foreground',
        valueContainer: () => 'gap-1 p-1 px-2',
      }}
    />
  );
};
